<template>
  <OnClickOutside
    :class="!settingsLink && !notificationLink && 'ml-auto'"
    @trigger="() => updateOpen(false)">

    <button
      type="button"
      class="-mr-2 ml-3 hidden md:block"
      @click="() => updateOpen(!props.open)">

      <UtilityProfileInitials
        size="md"
        :name="accountStore.user?.activeEnterprise?.name"
        :avatar="accountStore.user?.activeEnterprise?.avatar"
        class="cursor-pointer"/>

    </button>

    <TransitionDropdown>

      <div
        v-if="props.open"
        class="absolute top-16 right-20 z-50 mr-2 hidden rounded bg-white px-2 text-slate-500 shadow md:block">

        <RouterLink
          to="/launch-pad"
          class="flex items-center justify-start gap-3 px-4 py-3.5 hover:text-slate-900">
          <ArrowsRightLeftIcon
            class="h-4 w-4"/>
          Switch Accounts
        </RouterLink>
      </div>

    </TransitionDropdown>

  </OnClickOutside>
</template>

<script setup>
import TransitionDropdown from "./TransitionDropdown.vue";
import UtilityProfileInitials from "./UtilityProfileInitials.vue";
import {ArrowsRightLeftIcon} from "@heroicons/vue/24/outline/index.js";
import {OnClickOutside} from "@vueuse/components";
import {useAccountStore} from "../stores/AccountStore";

const emits = defineEmits(["update:open"]);
const props = defineProps({
  open: Boolean,
  settingsLink: String,
  notificationLink: String,
});

const accountStore = useAccountStore();

const updateOpen = (open) => emits("update:open", open);
</script>
